/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { metricsGetApiV3MetricsRegisteredCanistersCount } from "../../funcs/metricsGetApiV3MetricsRegisteredCanistersCount.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations
    .GetApiV3MetricsRegisteredCanistersCountRequest$inboundSchema.optional(),
};

export const tool$metricsGetApiV3MetricsRegisteredCanistersCount:
  ToolDefinition<typeof args> = {
    name: "metrics-get-api-v3-metrics-registered-canisters-count",
    description: ``,
    args,
    tool: async (client, args, ctx) => {
      const [result, apiCall] =
        await metricsGetApiV3MetricsRegisteredCanistersCount(
          client,
          args.request,
          { fetchOptions: { signal: ctx.signal } },
        ).$inspect();

      if (!result.ok) {
        return {
          content: [{ type: "text", text: result.error.message }],
          isError: true,
        };
      }

      const value = result.value;

      return formatResult(value, apiCall);
    },
  };
